import en from './en';
import ro from './ro';

export { KEYS } from './keys';

export const LANGUAGES = {
    en: {
        label: 'English',
        flag: '🇬🇧',
        translations: en,
    },
    ro: {
        label: 'Română',
        flag: '🇷🇴',
        translations: ro,
    },
};

export const DEFAULT_LANG = 'en';

/**
 * Pure translation helper.
 * @param {string} key - A key from KEYS
 * @param {string} lang - Language code (e.g. 'en', 'ro')
 * @returns {string}
 */
export function t(key, lang) {
    const langData = LANGUAGES[lang] ?? LANGUAGES[DEFAULT_LANG];
    return langData.translations[key] ?? LANGUAGES[DEFAULT_LANG].translations[key] ?? key;
}
